import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
  TextField,
  Button,
  Snackbar,
  Alert,
  Card,
  CardContent,
  Typography,
  Box,
  InputAdornment,
  Divider,
} from '@mui/material';
import { Lock, Person, VpnKey, QrCode2, CheckCircle } from '@mui/icons-material';
import { API_BASE_URL } from '../constant/constant';

const TwoFactorAuth = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [otp, setOtp] = useState('');
  const [qr, setQr] = useState('');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [is2FASetup, setIs2FASetup] = useState(false);
  const [message, setMessage] = useState('');
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackSeverity, setSnackSeverity] = useState('info');

  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const res = await axios.post(`${API_BASE_URL}/api/2falogin`, {
        userId: username,
        password,
      });

      if (res.data.secret) {
        setIsAuthenticated(true);
        setIs2FASetup(true);
      } else {
        const setupRes = await axios.get(`${API_BASE_URL}/2fa/setup/${username}`);
        setQr(setupRes.data.qr);
        setIsAuthenticated(true);
        setIs2FASetup(false);
      }
    } catch (err) {
      showMessage(`${err.response?.data?.message || 'Login failed'}`, 'error');
    }
  };

  const verifyOTP = async (otpValue = otp) => {
    try {
      const res = await axios.post(`${API_BASE_URL}/2fa/verify`, {
        username,
        token: otpValue,
      });

      showMessage(`${res.data.message}`, 'success');

      localStorage.setItem('token', res.data.jwttoken);
      sessionStorage.setItem('token', res.data.jwttoken);

      localStorage.setItem('isAuthenticated', 'true');
      localStorage.setItem('tokenData', res.data.encrypted);
      localStorage.setItem('expiryTime', res.data.expiryTime);

      navigate('/dashboard');
    } catch (err) {
      showMessage(`${err.response?.data?.message || 'OTP verification failed'}`, 'error');
    }
  };

  const showMessage = (msg, severity) => {
    setMessage(msg);
    setSnackSeverity(severity);
    setSnackOpen(true);
  };

  useEffect(() => {
    const alreadyAuthenticated = localStorage.getItem('isAuthenticated') === 'true';
    if (!alreadyAuthenticated) {
      navigate('/', { replace: true });
      localStorage.setItem('isAuthenticated', 'false');
      localStorage.clear();
      sessionStorage.clear();
    }
  }, [navigate]);

  return (
    <Box
      sx={{
       height: "100vh", // full screen, no extra scroll
     //   width: "50vw",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
     //   p: { xs: 2, md: 5 },
        overflow: "hidden", // ✅ prevent scrollbar
        background: { xs: "linear-gradient(to right, #150232ff 50%)", md: "linear-gradient(to right, #542511ff 50%, #dcbea0ff 50%)" },
        position: "relative",
      }}
    >
      <Box>
        <Typography
          variant="subtitle2"
          sx={{
            position: "absolute",
            top: 8,
            left: 12,
            color: "#fff",
            textShadow: "1px 1px 3px rgba(0,0,0,0.5)",
          }}
        >
          <Box component="span" sx={{ fontWeight: "normal", fontSize: 14, display: { xs: "none", md: "block" } , mt:1.0}}>
            Software ✍️ by
          </Box>

          <Box
            component="span"
            sx={{
              fontWeight: "bold",
              fontSize: 25,
              display: { xs: "none", md: "block" },
              mt: { xs: 0.1, md: 0.5 },
            }}
          >
            Sriyansh Computers
          </Box>

          <Box
           // component="span"
            sx={{
              fontWeight: "bold",
              fontSize: 14,
              mt: { xs: 0.5, md: 50.0 },
              
            }}
          >
            Helpline : 📞 9450887365
          </Box>

        </Typography>
      </Box>
      {/* 
<Typography
  variant="subtitle2"
  sx={{
    position: "absolute",
    bottom: 8, // 👈 moves it to the bottom
    left: 12,
    color: "#fff",
    fontWeight: "bold",
    textShadow: "1px 1px 3px rgba(0,0,0,0.5)",
  }}
>
  Software developed by Sriyansh Computers
</Typography>
<Typography
  variant="subtitle2"
  sx={{
    position: "absolute",
    top: 8,       // 👈 move to top
    right: 12,    // 👈 align right instead of left
    color: "#fff",
    fontWeight: "bold",
    textShadow: "1px 1px 3px rgba(0,0,0,0.5)",
  }}
>
  Software developed by Sriyansh Computers
</Typography>

<Typography
  variant="subtitle2"
  sx={{
    position: "absolute",
    bottom: 8,       // 👈 move to top
    right: 12,    // 👈 align right instead of left
    color: "#fff",
    fontWeight: "bold",
    textShadow: "1px 1px 3px rgba(0,0,0,0.5)",
  }}
>
  Software developed by Sriyansh Computers
</Typography> */}



      <Card
        sx={{
         //  width: "80vw",
       //height: "50vh",
          borderRadius: '20px',
          boxShadow: '0 8px 32px rgba(21, 20, 20, 0.2)',
          backdropFilter: 'blur(12px) saturate(180%)',
          //  background: 'rgba(255, 255, 255, 0.25)', // lighter white overlay
          border: '1px solid rgba(130, 121, 121, 0.3)',
          padding: 2,
          //zIndex: 1,
        }}
      >
        <CardContent>
          {/* --- Your main component code remains same --- */}
          <Typography
            variant="h6"
            gutterBottom
            textAlign="center"
            sx={{ fontWeight: 'normal', mt: 0, color: 'red',marginBottom: 4 }}

          >
            🔐 Enter Your Identification
          </Typography>
          <Divider sx={{ mb: 2 }} />

          {!isAuthenticated ? (
            <Box display="flex" flexDirection="column" gap={2} mt={4}>
              <TextField
                size="small"
                label="Username"
                variant="outlined"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && handleLogin()}
                autoFocus
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      👤      
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                label="Password"
                variant="outlined"
                size="small"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && handleLogin()}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                     🔑
                    </InputAdornment>
                  ),
                }}
              />
              <Button
                variant="contained"
                color="primary"
                onClick={handleLogin}
                startIcon={<VpnKey />}
                sx={{ borderRadius: '30px', fontWeight: 'bold', py: 1, mt: 4,marginBottom: 4 }}
              >
                Login
              </Button>
            </Box>
          ) : (
            <Box display="flex" flexDirection="column" gap={2} mt={2}>
              {!is2FASetup ? (
                <>
                  <Typography
                    variant="body1"
                    textAlign="center"
                    sx={{ fontWeight: 'bold', mt: 1, color: 'red' }}
                  >
                    📱 Scan this QR with Google Authenticator:
                  </Typography>
                  <Box textAlign="center">
                    <img src={qr} alt="QR Code" style={{ maxWidth: '100%', height: 200 }} />
                  </Box>
                  <Typography variant="body2" textAlign="center">
                    🔢 Then enter the OTP below:
                  </Typography>
                </>
              ) : (
                <Typography
                  variant="body1"
                  textAlign="center"
                  sx={{ fontWeight: 'bold', mt: 1, color: 'navy' }}
                >
                  🔑 Enter OTP from Authenticator:
                </Typography>
              )}

              <TextField
                label="Enter OTP"
                variant="outlined"
                value={otp}
                type="tel"
                size="small"
                inputProps={{
                  inputMode: 'numeric',
                  pattern: '[0-9]*',
                  maxLength: 6,
                }}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, '');
                  setOtp(value);
                  if (value.length === 6) {
                    verifyOTP(value);
                  }
                }}
                onKeyDown={(e) => e.key === 'Enter' && verifyOTP()}
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <QrCode2 />
                    </InputAdornment>
                  ),
                }}
              />

              <Button
                variant="contained"
                color="success"
                onClick={verifyOTP}
                startIcon={<CheckCircle />}
                sx={{ borderRadius: '30px', fontWeight: 'bold', py: 1, mt: 4,marginBottom: 4 }}
              >
                Verify OTP
              </Button>
            </Box>
          )}
        </CardContent>
      </Card>

      <Snackbar
        open={snackOpen}
        autoHideDuration={4000}
        onClose={() => setSnackOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setSnackOpen(false)}
          severity={snackSeverity}
          variant="filled"
          sx={{ borderRadius: '8px', fontWeight: 'bold' }}
        >
          {message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default TwoFactorAuth;
